export const THEME = 'data-theme';
export const SUCCESS = 'data-success';
export const ERROR = 'data-error';
export const EMPTY = 'data-empty-state';
export const DATA_HOOKS = {
    ROOT: 'text-field-root',
    CLEAR_BUTTON: 'clear-button',
    LABEL: 'label',
    FLOATING_LABEL: 'floating-label',
    LABEL_PLACEHOLDER: 'label-placeholder',
    ERROR_ICON: 'error-Icon',
    ERROR_TOOLTIP_ICON: 'error-tooltip-icon',
    SUCCESS_ICON: 'success-Icon',
    CUSTOM_SUFFIX: 'custom-suffix',
    CHAR_COUNT: 'char-count',
    PREFIX: 'prefix',
    PREFIX_LABEL: 'prefix-label',
    ARROW_ICONS: 'arrow-icons',
    HELPER_TEXT: 'helper-text',
    VISIBILITY_BUTTON: 'visibility-button',
    HIDDEN_ICON: 'hidden-icon',
    VISIBLE_ICON: 'visible-icon',
};
//# sourceMappingURL=dataKeys.js.map